'use strict';

var Inflections = require('../../common/var/Inflections'),
    coreUtilityAliases = require('../../common/var/coreUtilityAliases');

var forEachProperty = coreUtilityAliases.forEachProperty;

function buildAcronymReg() {
  var tokens = [];
  forEachProperty(Inflections.acronyms.map, function(val, key) {
    if (key === val) {
      tokens.push(val);
    }
  });
  // Sort by length to ensure that tokens
  // like HTTPS take precedence over HTTP.
  tokens.sort(function(a, b) {
    return b.length - a.length;
  });
  Inflections.acronyms.reg = RegExp('\\b' + tokens.join('|') + '\\b', 'g');
}

module.exports = buildAcronymReg;